import { Eyebrow, Reveal } from "./Reveal";

const ITEMS = [
    {
        n: "01",
        title: "Presisi Ukuran Lapangan",
        desc: "Setiap proyek dimulai dari pengukuran langsung — bukan tebakan, bukan perkiraan.",
    },
    {
        n: "02",
        title: "Material Terpilih",
        desc: "Profil aluminium dan kaca tempered berkualitas dengan akesoris yang tidak asal tempel.",
    },
    {
        n: "03",
        title: "Rapi & Tepat Waktu",
        desc: "Jadwal disepakati di awal, area kerja dibersihkan, hasil tidak perlu Anda perbaiki dua kali.",
    },
    {
        n: "04",
        title: "Garansi Pemasangan",
        desc: "Kalau ada yang kurang pas pada pengerjaan kami, kami kembali membetulkannya.",
    },
];

export default function Advantages() {
    return (
        <section className="bg-surface/40 py-24 lg:py-32">
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
                <Reveal>
                    <Eyebrow>Kenapa Daruna</Eyebrow>
                </Reveal>
                <Reveal delay={0.05}>
                    <h2 className="mt-6 max-w-2xl font-serif text-4xl font-medium leading-tight text-white lg:text-5xl">
                        Pekerjaan kaca memaafkan sedikit kesalahan.
                    </h2>
                </Reveal>

                <div className="mt-14 border-t border-white/10">
                    {ITEMS.map((it, i) => (
                        <Reveal key={it.n} delay={i * 0.05}>
                            <div
                                data-testid="advantage-row"
                                className="group grid grid-cols-[auto_1fr] items-baseline gap-6 border-b border-white/10 py-8 transition-[padding] duration-500 hover:pl-3 lg:grid-cols-[80px_1fr_1.2fr] lg:gap-10 lg:py-10"
                            >
                                <span className="font-mono text-sm text-gold">
                                    {it.n}
                                </span>
                                <h3 className="font-serif text-2xl text-white lg:text-3xl">
                                    {it.title}
                                </h3>
                                <p className="col-span-2 text-sm leading-relaxed text-zinc-400 lg:col-span-1">
                                    {it.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
